import React from 'react';
import {
  useDraggable,
} from '@dnd-kit/core';
import PropTypes from 'prop-types';
import ItemVisual from './ItemVisual';

const ITEM_SIZE = 64;

const DraggableItemComponent = React.memo(({ item, isDragging, objekte, triggerAction }) => {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: item.id,
    data: { item, type: 'board-item' }, 
  });

  const style = {
    position: 'absolute',
    left: item.x,
    top: item.y,
    width: ITEM_SIZE,
    height: ITEM_SIZE,
    zIndex: isDragging ? 50 : 10,
    opacity: isDragging ? 0 : 1, 
    transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
      className="cursor-grab hover:shadow-lg active:cursor-grabbing"
    >
       <ItemVisual type={item.type} objekte={objekte} triggerAction={triggerAction}/>
    </div>
  );
});

DraggableItemComponent.propTypes = {
  item: PropTypes.object.isRequired,
  isDragging: PropTypes.bool,
};

export default DraggableItemComponent